import AddAccountHome from "../Components/AddAccountHome";
import { ADD_ACCOUNT_DESCRIPTION_SETTINGS } from "../utils/constants";

export default function AccountsSettings() {
    return (
        <AddAccountHome
            descriptionText={ADD_ACCOUNT_DESCRIPTION_SETTINGS}
        />
    )
}